/**
 * Inline badge for the venue detail page (port of the design's NBTeacherEye):
 * marks whether a logistics field shows on the teacher day-of card or stays
 * internal.
 */
import { Users } from 'lucide-react';

export function TeacherEye({ on }: { on: boolean }) {
  return (
    <span
      title={on ? 'Shown on the teacher day-of card' : 'Internal — hidden from teachers'}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        fontSize: 9,
        fontWeight: 700,
        letterSpacing: '.05em',
        textTransform: 'uppercase',
        color: on ? 'var(--nb-primary)' : 'var(--nb-faint)',
        whiteSpace: 'nowrap',
      }}
    >
      <Users size={10} />
      {on ? 'teachers see this' : 'internal'}
    </span>
  );
}
